export default function convertPxToRem(pixels) {
  // @media is always calculated off 16px regardless of whether the root font size is the default or not
  return "".concat(pixels / 16, "rem");
}